






























































































































import Dinero from "dinero.js";
import { computed, defineComponent, reactive } from "@vue/composition-api";
import MoneyInput from "@/components/lien/form/MoneyInput.vue";
import CodeSearch from "@/components/lien/CodeSearch.vue";
import DateInput from "@/components/lien/form/DateInput.vue";

interface EntryForm {
  icn: string;
  providerName: string;
  icdInd: string;
  dxCodes: {
    bold: boolean;
    code: string;
    codeid: string;
    codename: string;
    codeset: string;
    year: string;
  }[];
  pxCodes: {
    code: string;
    codeid: string;
    codename: string;
    codeset: string;
    year: string;
  }[];
  fromDate: Date | null;
  toDate: Date | null;
  conditionalPayment: Dinero.Dinero;
  related: boolean | null;
  rationale: number | null;
  notes: string;
}

export default defineComponent({
  name: "EntryForm",
  components: { DateInput, CodeSearch, MoneyInput },
  setup() {
    const entry = reactive<EntryForm>({
      icn: "",
      providerName: "",
      icdInd: "ICD-10",
      dxCodes: [],
      pxCodes: [],
      fromDate: null,
      toDate: null,
      conditionalPayment: Dinero(),
      related: null,
      rationale: null,
      notes: ""
    });

    const size = computed(() =>
      Math.max(entry.dxCodes.length, entry.pxCodes.length)
    );

    const reset = () => {
      entry.icn = "";
      entry.providerName = "";
      entry.icdInd = "ICD-10";
      entry.dxCodes = [];
      entry.pxCodes = [];
      entry.fromDate = null;
      entry.toDate = null;
      entry.conditionalPayment = Dinero();
      entry.related = null;
      entry.rationale = [];
      entry.notes = "";
    };

    const isValid = computed(
      () =>
        entry.icn.length > 0 &&
        entry.providerName.length > 0 &&
        entry.icdInd.length > 0 &&
        entry.dxCodes.length > 0 &&
        entry.fromDate !== null &&
        entry.toDate !== null
    );

    return { entry, reset, size, isValid };
  }
});
